import Axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

class ScanService {

  scanWebsite = (data) => {
    return Axios.post(`${API_URL}/scan`, data)
      .then(function (response) {
        const {
          data
        } = response;
        return data;
      }).catch((error) => {
        console.log(error);
      })
  }

  submitReport = (data) => {
    return Axios.post(`${API_URL}/send_pdf_email`, data)
      .then(function (response) {
        const {
          data
        } = response;
        return data;
      }).catch((error) => {
        console.log(error);
      })
  }

  storeContact = (data) => {
    return Axios.post(`${API_URL}/store_contact`, data)
      .then(function (response) {
        const {
          data
        } = response;
        return data;
      }).catch((error) => {
        console.log(error);
      })
  }
}

export default new ScanService();